import React, { useState } from 'react';
import { motion } from 'motion/react';

import './Projects.css';
import './Projects.mobile.css';
import NavBar from '../../components/navbar/NavBar'
import Footer from '../../components/footer/Footer';
import StickyNote1 from '../../assets/images/sticky-note1.png';
import StickyNote2 from '../../assets/images/sticky-note2.png';
import StickyNote3 from '../../assets/images/sticky-note3.png';
import StickyNote4 from '../../assets/images/sticky-note4.png';
import StickyNote6 from '../../assets/images/sticky-note6.png';
import Sparkles1 from '../../assets/images/corner-sparkle1.png';
import Sparkles2 from '../../assets/images/corner-sparkle2.png';

const fadeInNote = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.6, margin: '0px 0px -25% 0px' },
    transition: { duration: 0.6, ease: 'easeOut' },
};

const Projects = ({ setLang, lang }) => {
    const [imagesLoaded, setImagesLoaded] = useState({
        note1: false,
        note2: false,
        note3: false,
        note4: false,
        note5: false
    });

    return (
        <div className="projects-container">
            <div className="header-sticky">
                <NavBar section='projects' setLang={setLang} lang={lang} />
            </div>
            <div className="projects-header">
            </div>
            <div className="project-notes">
                <div className="project-notes-row">
                    <a href="https://github.com/stelladeloreyy/neural-network-scratch" target="_blank" rel="noopener noreferrer">
                        <motion.div
                            className="sticky-note sticky-note-overlay"
                            {...fadeInNote}
                            whileHover={{ scale: 1.08, zIndex: 100 }}
                            whileTap={{ scale: 1.03, zIndex: 90 }}
                            transition={{ duration: 0.6, ease: 'easeOut', scale: { duration: 0.18, ease: 'easeOut' } }}
                        >
                            <span className="sticky-note-text note-1">
                                {lang === "fr" ? (
                                    <div className="header">
                                        <h1>R</h1><h2>éseau </h2>
                                        <h2>Neuronal</h2> 
                                    </div>
                                ): (
                                    <div className="header">
                                        <h1>N</h1><h2>eural </h2>
                                        <h2>Network</h2> 
                                    </div>
                                    )
                                }
                                {lang === "fr" ? (
                                    <div className="bullet-points">
                                       <p>♡ <b>Classification des images</b> à l'aide d'un réseau neuronal à 2 couches</p>
                                        <p>♡ Utilise ReLu & Softmax comme fonctions d'activation</p>
                                        <p>♡ Créé avec <b>Python</b> en utilisant <b>NumPy, Pandas</b> & <b>MatPlotLib</b></p>
                                    </div>
                                ) : (
                                    <div className="bullet-points">
                                        <p>♡ <b>Image classification</b> using a 2-layer Neural Network</p>
                                        <p>♡ Uses ReLu & Softmax as activation functions</p>
                                        <p>♡ Created with <b>Python</b> using <b>NumPy, Pandas</b> & MatPlotLib</p>
                                    </div>
                                )}
                            </span>
                            <motion.img
                                src={StickyNote1}
                                alt="Sticky Note"
                                className="sticky-img"
                                initial={{ opacity: 0, y: 20 }}
                                animate={imagesLoaded.note1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.6, ease: 'easeOut' }}
                                onLoad={() => setImagesLoaded(prev => ({ ...prev, note1: true }))}
                            />
                            <img src={Sparkles1} className="show-grow1" alt="Sticky Note" />
                            <img src={Sparkles2} className="show-grow2" alt="Sticky Note" />
                        </motion.div>
                    </a>
                    <a href="https://github.com/stelladeloreyy/doodles" target="_blank" rel="noopener noreferrer">
                        <motion.div
                            className="sticky-note"
                            {...fadeInNote}
                            whileHover={{ scale: 1.08, zIndex: 100 }}
                            whileTap={{ scale: 1.03, zIndex: 90 }}
                            transition={{ duration: 0.6, ease: 'easeOut', scale: { duration: 0.18, ease: 'easeOut' } }}
                        >
                            <span className="sticky-note-text note-2">
                                <div className="header">
                                    <h1>D</h1><h2>oodle </h2>
                                    <h2>Canvas</h2> 
                                </div>
                                {lang === "fr" ? (
                                    <div className="bullet-points">
                                       <p>♡ Les utilisateurs peuvent dessiner et enregistrer des œuvres d'art, puis admirer une galerie publique stockée dans une base de données <b>Postgres</b></p>
                                        <p>♡ Utilise l'algorithme Chaikin pour les lignes tracées</p>
                                        <p>♡ Créé avec <b>Typescript, NodeJS, Express</b> & <b>Postgres</b></p>
                                    </div>
                                ) : (
                                    <div className="bullet-points">
                                        <p>♡ Lets users draw & save artwork, then check out a public gallery stored in <b>Postgres database</b></p>
                                        <p>♡ Uses Chaikin's Algorithm for smoothing lines drawn</p>
                                        <p>♡ Created with <b>Typescript, NodeJS, Express</b> & <b>Postgres</b></p>
                                    </div>
                                )}
                            </span>
                            <motion.img
                                src={StickyNote2}
                                alt="Sticky Note"
                                className="sticky-img"
                                initial={{ opacity: 0, y: 20 }}
                                animate={imagesLoaded.note2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.6, ease: 'easeOut' }}
                                onLoad={() => setImagesLoaded(prev => ({ ...prev, note2: true }))}
                            />
                            <img src={Sparkles1} className="show-grow1" alt="Sticky Note" />
                            <img src={Sparkles2} className="show-grow2" alt="Sticky Note" />
                        </motion.div>
                    </a>
                    <a href="https://github.com/stelladeloreyy/personal-website" target="_blank" rel="noopener noreferrer">
                        <motion.div
                            className="sticky-note"
                            {...fadeInNote}
                            whileHover={{ scale: 1.08, zIndex: 100 }}
                            whileTap={{ scale: 1.03, zIndex: 90 }}
                            transition={{ duration: 0.6, ease: 'easeOut', scale: { duration: 0.18, ease: 'easeOut' } }}
                        >
                            <span className="sticky-note-text note-3">
                                {lang === "fr" ? (
                                    <div className="header">
                                        <h1>S</h1><h2>ite </h2>
                                        <h2>Portefeuille</h2> 
                                    </div>
                                ): (
                                    <div className="header">
                                        <h1>P</h1><h2>orfolio </h2>
                                        <h2>Website</h2> 
                                    </div>
                                    )
                                }
                                {lang === "fr" ? (
                                    <div className="bullet-points">
                                       <p>♡ Le site que vous consultez maintenant!</p>
                                        <p>♡ Conçu en <b>Figma</b>, tout est dessiné par moi-même</p>
                                        <p>♡ Créé avec <b>Javascript, React, HTML</b> & <b>CSS</b></p>
                                    </div>
                                ) : (
                                    <div className="bullet-points">
                                        <p>♡ The website you're looking at now!</p>
                                        <p>♡ Designed in <b>Figma</b>, everything drawn by yours truly</p>
                                        <p>♡ Created with <b>Javascript, React, HTML</b> & <b>CSS</b></p>
                                    </div>
                                )}
                            </span>
                            <motion.img
                                src={StickyNote6}
                                alt="Sticky Note"
                                className="sticky-img"
                                initial={{ opacity: 0, y: 20 }}
                                animate={imagesLoaded.note3 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.6, ease: 'easeOut' }}
                                onLoad={() => setImagesLoaded(prev => ({ ...prev, note3: true }))}
                            />
                            <img src={Sparkles1} className="show-grow1" alt="Sticky Note" />
                            <img src={Sparkles2} className="show-grow2" alt="Sticky Note" />
                        </motion.div>
                    </a>
                </div>
                <div className="project-notes-row">
                    <a href="https://www.youtube.com/watch?v=Dc9jRdJnqRA" target="_blank" rel="noopener noreferrer">
                        <motion.div
                            className="sticky-note"
                            {...fadeInNote}
                            whileHover={{ scale: 1.08, zIndex: 100 }}
                            whileTap={{ scale: 1.03, zIndex: 90 }}
                            transition={{ duration: 0.6, ease: 'easeOut', scale: { duration: 0.18, ease: 'easeOut' } }}
                        >
                            <span className="sticky-note-text note-4">
                                <div className="header">
                                    <h1>K</h1><h2>atalyst </h2>
                                </div>
                                {lang === "fr" ? (
                                    <div className="bullet-points">
                                        <p>♡ Application de bureau pour trouver des projets et initiatives locaux</p>
                                        <p>♡ Système de messagerie en direct et algorithme de recommandation</p>
                                        <p>♡ Créé avec <b>Kotlin</b>, <b>Jetpack Compose</b>, & <b>Supabase</b></p>
                                    </div>
                                ) : (
                                    <div className="bullet-points">
                                        <p>♡ Desktop application for finding local projects & initiatives</p>
                                        <p>♡ Supports live messaging system and recommendation algorithm </p>
                                        <p>♡ Created with <b>Kotlin</b>, <b>Jetpack Compose</b>, & <b>Supabase</b></p>
                                    </div>
                                )}
                            </span>
                            <motion.img
                                src={StickyNote3}
                                alt="Sticky Note"
                                initial={{ opacity: 0, y: 20 }}
                                animate={imagesLoaded.note4 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.6, ease: 'easeOut' }}
                                onLoad={() => setImagesLoaded(prev => ({ ...prev, note4: true }))}
                            />
                            <img src={Sparkles1} className="show-grow1" alt="Sticky Note" />
                            <img src={Sparkles2} className="show-grow2" alt="Sticky Note" />
                        </motion.div>
                    </a>
                    <a href="https://github.com/stelladeloreyy/biquadris" target="_blank" rel="noopener noreferrer">
                        <motion.div
                            className="sticky-note"
                            {...fadeInNote}
                            whileHover={{ scale: 1.08, zIndex: 100 }}
                            whileTap={{ scale: 1.03, zIndex: 90 }}
                            transition={{ duration: 0.6, ease: 'easeOut', scale: { duration: 0.18, ease: 'easeOut' } }}
                        >
                            <span className="sticky-note-text note-5">
                                <div className="header">
                                    <h1>B</h1><h2>iquadris </h2>
                                </div>
                                {lang === "fr" ? (
                                    <div className="bullet-points">
                                        <p>♡ Jeu de blocs tombants à deux joueurs inspiré par Tetris</p>
                                        <p>♡ Exécuté sous forme de texte ou de graphique à l'aide de <b>X11</b></p>
                                        <p>♡ Créé avec <b>C++</b> en utilisant seulement la bibliothèque STD</p>
                                    </div>
                                ) : (
                                    <div className="bullet-points">
                                        <p>♡ Two-player falling-block game inspired by Tetris</p>
                                        <p>♡ Can be run as text or graphically using <b>X11</b></p>
                                        <p>♡ Created with <b>C++</b> using only STD library</p>
                                    </div>
                                )}
                            </span>
                            <motion.img
                                src={StickyNote4}
                                alt="Sticky Note"
                                initial={{ opacity: 0, y: 20 }}
                                animate={imagesLoaded.note5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.6, ease: 'easeOut' }}
                                onLoad={() => setImagesLoaded(prev => ({ ...prev, note5: true }))}
                            />
                            <img src={Sparkles1} className="show-grow1" alt="Sticky Note" />
                            <img src={Sparkles2} className="show-grow2" alt="Sticky Note" />
                        </motion.div>
                    </a>
                </div>
            </div>
            <motion.div
                className="footer"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
            >
                <Footer lang={lang} />
            </motion.div>
        </div>
    );
};

export default Projects;